module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "20rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.actionCaption),
      expression: "cxt.actionCaption"
    }],
    attrs: {
      "light": "",
      "flat": _vm.flat
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cxt.actionCaption) + "\n      "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.actionCaption),
      expression: "!cxt.actionCaption"
    }],
    attrs: {
      "icon": "",
      "light": ""
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.cxt.actionIcon))])], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isSelectMode()),
      expression: "cxt.isSelectMode()"
    }]
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.cxt.isFilterMode() && _vm.isMobile)),
      expression: "!(cxt.isFilterMode() && isMobile)"
    }],
    attrs: {
      "light": "",
      "flat": _vm.flat
    }
  }, [_vm._v("\n      Операции\n      "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.isMobile),
      expression: "cxt.isFilterMode() && isMobile"
    }],
    attrs: {
      "icon": "",
      "light": "",
      "flat": _vm.flat
    }
  }, [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1)]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.cxt.getActions()), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c80add74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/OpsBtn.vue
// module id = 859
// module chunks = 1